"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SearchableNestedDropdown_context_1 = require("../SearchableNestedDropdown.context");
var HeaderEmpty_1 = require("./HeaderEmpty");
var HeaderFolder_1 = require("./HeaderFolder");
var HeaderSearch_1 = require("./HeaderSearch");
var HeaderValue_1 = require("./HeaderValue");
exports.default = React.forwardRef(function (_, ref) {
    var _a = React.useContext(SearchableNestedDropdown_context_1.SndContext), Value = _a.Value, Parent = _a.Parent, IsDropdownOpen = _a.IsDropdownOpen;
    return (React.createElement(React.Fragment, null,
        !Value && !IsDropdownOpen && React.createElement(HeaderEmpty_1.default, null),
        Value && !IsDropdownOpen && React.createElement(HeaderValue_1.default, null),
        !Parent && IsDropdownOpen && React.createElement(HeaderSearch_1.default, { ref: ref }),
        Parent && IsDropdownOpen && React.createElement(HeaderFolder_1.default, { ref: ref })));
});
